import Sortable from 'sortablejs';
import { Controller } from "@hotwired/stimulus"
import { flashError } from '../config/flash'

// Connects to data-controller="sortable"
export default class extends Controller {
  static values = {
    url: String
  }

  get order() {
    return Array.from(this.element.children).map(x => x.dataset.id)
  }

  initialize() {
    this.onUpdate = this.onUpdate.bind(this)
  }

  connect() {
    console.log('connect')
    console.log(this.urlValue)
    Sortable.create(this.element, {
      ghostClass: "ghost",
      onUpdate: this.onUpdate
    })
  }

  // private

  onUpdate() {
  try {
    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content
      },
      body: JSON.stringify({order: this.order})
    })
    .then((response) => {
      if (response.ok)
        return response.text()
      else
       flashError("Impossible de sauvegarder l'ordre")
    })
    .then(html => Turbo.renderStreamMessage(html))
    } catch (error) {
      flashError("Impossible de sauvegarder l'ordre")
    }
  }
}
